import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import { DashboardStoreInfoReport } from "@/features/reports/components/DashboardStoreInfoReport"
import {
  storeInfoQuery,
  STORE_INFO_DEFAULTS,
} from "@/features/reports/core/hooks/useStoreInfoReport"

const SearchParams = z.object({
  status: z.enum(PROJECT_STATUSES).optional(),
})

export const Route = createFileRoute("/(authenticated)/reports/dashboard-store-info")({
  validateSearch: SearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient.ensureQueryData(
      storeInfoQuery({
        ...STORE_INFO_DEFAULTS,
        status: deps.status ?? STORE_INFO_DEFAULTS.status,
      }),
    )
  },
  component: DashboardStoreInfoReport,
})
